
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/catalogue",
      function () {
        return require("private-next-pages/[locale]/catalogue/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/catalogue"])
      });
    }
  